import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import "../styles/Navbar.css";

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [dropdownState, setDropdownState] = useState({
    services: false,
    platforms: false,
    rules: false,
  });

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
    setDropdownState({ services: false, platforms: false, rules: false }); 
  };

  const toggleDropdown = (key) => {
    setDropdownState((prevState) => ({
      ...prevState,
      [key]: !prevState[key], // Toggle the specific dropdown's state
    }));
  };

  const services = [
    { name: "Cricket Betting", id: "cricket-betting" },
    { name: "Tennis Betting", id: "tennis-betting" },
    { name: "Indian Card Games", id: "indian-card-games" },
    { name: "Football Betting", id: "football-betting" },
    { name: "Horse Race Betting", id: "horse-race-betting" },
    { name: "Casino", id: "casino" },
  ];

  const platforms = [
    { name: "11xPlay", id: "11xplay" },
    { name: "Laser247", id: "laser247" },
    { name: "Cricbet99", id: "cricbet99" },
  ];

  const rules = [
    { name: "Privacy Policy", id: "privacy-policy" },
    { name: "Terms & Conditions", id: "terms-and-conditions" },
    { name: "Disclaimer", id: "disclaimer" },
  ];

  return (
    <nav className="navbar">
      <div className="logo">
        <RouterLink to="/">
          <img src="/logo.webp" alt="Logo" />
        </RouterLink>
      </div>
      <div className="hamburger" onClick={toggleMenu}>
        &#9776;
      </div>
      <div className={`overlay ${isOpen ? 'open' : ''}`} onClick={closeMenu}></div>
      <ul className={`nav-links ${isOpen ? 'open' : ''}`}>
        <span className="close-menu" onClick={closeMenu}>&times;</span>
        <li>
          <RouterLink to="/" onClick={closeMenu}>
            Home
          </RouterLink>
        </li>
        <li>
          <RouterLink to="/about" onClick={closeMenu}>
            About
          </RouterLink>
        </li>
        {/* Services Dropdown */}
        <li className="dropdown-container">
          <div
            className="dropdown-header"
            onClick={() => toggleDropdown('services')}
          >
            <RouterLink to="/services" onClick={closeMenu}>
              Services
            </RouterLink>
            <span className="dropdown-arrow">▼</span>
          </div>
          <ul className={`dropdown ${dropdownState.services ? 'open' : ''}`}>
            {services.map((service) => (
              <li key={service.id}>
                <RouterLink
                  to={`/${service.id}`}
                  onClick={closeMenu}
                >
                  {service.name}
                </RouterLink>
              </li>
            ))}
          </ul>
        </li>
        {/* Platforms Dropdown */}
        <li className="dropdown-container">
          <div
            className="dropdown-header"
            onClick={() => toggleDropdown('platforms')}
          >
            <RouterLink to="/platforms" onClick={closeMenu}>
              Platforms
            </RouterLink>
            <span className="dropdown-arrow">▼</span>
          </div>
          <ul className={`dropdown ${dropdownState.platforms ? 'open' : ''}`}>
            {platforms.map((platform) => (
              <li key={platform.id}>
                <RouterLink
                  to={`/${platform.id}`}
                  onClick={closeMenu}
                >
                  {platform.name}
                </RouterLink>
              </li>
            ))}
          </ul>
        </li>
        {/* Rules Dropdown */}
        <li className="dropdown-container">
          <div
            className="dropdown-header"
            onClick={() => toggleDropdown('rules')}
          >
            <RouterLink to="#" onClick={closeMenu}>
              Rules
            </RouterLink>
            <span className="dropdown-arrow">▼</span>
          </div>
          <ul className={`dropdown ${dropdownState.rules ? 'open' : ''}`}>
            {rules.map((rule) => (
              <li key={rule.id}>
                <RouterLink
                  to={`/${rule.id}`}
                  onClick={closeMenu}
                >
                  {rule.name}
                </RouterLink>
              </li>
            ))}
          </ul>
        </li>
        <li>
          <RouterLink to="/blogs" onClick={closeMenu}>
            Blogs
          </RouterLink>
        </li>
        <li>
          <RouterLink to="/sports-id" onClick={closeMenu}>
            Sports ID
          </RouterLink>
        </li>
        <li>
          <RouterLink to="/contact" onClick={closeMenu}>
            Contact
          </RouterLink>
        </li>
      </ul>
    </nav>
  );
}

export default Navbar;
